import { useStrings } from "@1js/localization-components";
import { Column, Grid, Row } from "@1js/pl-card-components";
import {
  Text,
  makeStyles,
  shorthands,
  tokens,
} from "@fluentui/react-components";
import parse from "html-react-parser";
import * as React from "react";
import { useFlightContext } from "../../hooks/useFlightContext";
import { IsTeamsTab, TeamName } from "../../types";
import { isMetaOsHelper } from "../../utils/url";
import { MosSubHeading } from "../MosSubheading/MosSubheading.web";
import {
  MainSubtitleUnlicensed,
  MainTitle,
  MainTitleTeamTab,
  MainTitleV2,
} from "./PromptHeading.web.string";

const useStyles = makeStyles({
  container: {
    zIndex: 0,
    marginTop: "48px",
    ...shorthands.gap("8px"),
  },

  containerNoHeading: {
    zIndex: 0,
    marginTop: "0px",
    ...shorthands.gap("8px"),
  },

  containerMetaOs: {
    zIndex: 0,
    marginTop: "24px",
    ...shorthands.gap("8px"),
  },

  heading: {
    color: tokens.colorNeutralForeground1,
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: "52px",
    marginBottom: "0px",
    "@media (max-width: 540px)": {
      fontSize: "28px",
      lineHeight: "36px",
      marginTop: "0rem",
    },
  },

  headingLicensed: {
    color: tokens.colorNeutralForeground1,
    fontSize: "28px",
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: "26px",
    marginTop: "48px",
    marginBottom: "0px",
    "@media (max-width: 540px)": {
      fontSize: "28px",
      lineHeight: "36px",
      marginTop: "0rem",
    },
  },

  headingMetaOs: {
    color: tokens.colorNeutralForeground1,
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: "52px",
    marginBottom: "0px",
    "@media (max-width: 540px)": {
      fontSize: "28px",
      lineHeight: "36px",
      marginTop: "0rem",
    },
  },

  subHeading: {
    color: tokens.colorNeutralForeground3,
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: tokens.fontWeightRegular,
    lineHeight: "22px",
    maxWidth: "600px",

    "@media (max-width: 540px)": {
      width: "210px",
    },
  },
});

export const PromptHeading: React.FC = () => {
  const styles = useStyles();
  const localizations = useStrings({
    MainTitle,
    MainSubtitleUnlicensed,
    MainTitleV2,
    MainTitleTeamTab,
  });
  const { isFlightActive } = useFlightContext();
  const isTeamsTab = localStorage.getItem(IsTeamsTab);
  const teamTabName = localStorage.getItem(TeamName);

  const getHeadingClass = () => {
    let headingStyle = styles.heading;

    if (isFlightActive("isUserLicensed") && isTeamsTab === "false") {
      headingStyle = styles.headingLicensed;
    }

    if (isTeamsTab === "true") {
      headingStyle = styles.headingMetaOs;
    }

    return headingStyle;
  };

  const getContainerStyle = () => {
    if (isFlightActive("isMetaOSAppActive") && isTeamsTab === "true") {
      return styles.containerMetaOs;
    }

    if (isFlightActive("isMetaOSAppActive") && isTeamsTab === "false") {
      return styles.containerNoHeading;
    }

    return styles.container;
  };

  const getHeading = () => {
    if (isMetaOsHelper() && isTeamsTab === "true") {
      return parse(localizations.MainTitleTeamTab() + ": " + teamTabName);
    } else if (isMetaOsHelper() && isTeamsTab === "false") {
      return parse(localizations.MainTitleV2());
    } else {
      return parse(localizations.MainTitle());
    }
  };

  const showHeading = () => {
    if ((isMetaOsHelper() && isTeamsTab === "true") || !isMetaOsHelper()) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Grid
      className={getContainerStyle()}
      goBold={isFlightActive("isGoBoldPromptCardEnabled")}
      isResponsive={isFlightActive("isResponsiveDimensionsEnabled")}
    >
      {showHeading() && (
        <Row>
          <Column size={12}>
            <Text as="h1" align="center" className={getHeadingClass()}>
              {getHeading()}
            </Text>
          </Column>
        </Row>
      )}
      {isTeamsTab === "true" &&
        isFlightActive("isLinkToAppFromChannelEnabled") && <MosSubHeading />}
    </Grid>
  );
};
